export default "__VITE_ASSET__BHHxHSwZ__"